<template>
    <div class="o-alerts">
        <div class="o-alerts__mapWrapper">
            <transition  name="list"            >
                <div v-show="this.isMapOpened" class="o-alerts__heatmap" id="mapDiv" ref="heatmap"></div>
            </transition>
            <a-button class="o-alerts__mapButton" type="" @click="toggleMap">{{ this.isMapOpened ? 'Ukryj mapę' : 'Pokaż mapę' }}</a-button>
        </div>
        <div class="l-row m-card">
            <div class="l-row__column m-card__column">
                <div class="l-row m-card__container">
                    <m-control
                        v-if="dateRange"
                        type="dateRange"
                        name="dateRange"
                        label="Zakres dat"
                        :value="dateRange"
                        @input="dateRange = $event"
                    />
                       <m-control
                        :background-gray="true"
                        type="search"
                        label="Województwo"
                        placeholder="Znajdź..."
                        name="provinces"
                        model-name="provinces"
                        @input="build('province_id', $event)"
                        :value="query['provinces']"
                        :search-at-once="true"
                        :object="true"

                    />
                     <m-control
                        :background-gray="true"
                        type="search"
                        label="Powiat"
                        placeholder="Znajdź..."
                        name="counties"
                        model-name="counties"
                        @input="build('county_id', $event)"
                        :value="query['counties']"
                        :search-at-once="true"
                        :object="true"
                        :params="{provinceId: this.activeProvinceId}"
                    />
                     <m-control
                        :background-gray="true"
                        type="search"
                        label="Punkt"
                        placeholder="Znajdź..."
                        name="points"
                        model-name="points"
                        @input="build('point_id', $event)"
                        :value="query['points']"
                        :search-at-once="true"
                        :object="true"
                        :params="{county_id: this.activeCountyId}"

                    />

                    <m-control
                        :background-gray="true"
                        type="search"
                        label="Uprawa"
                        placeholder="Znajdź..."
                        name="crops"
                        model-name="crops"
                        @input="build('crop_id', $event)"
                        :value="query['crops']"
                        :search-at-once="true"
                        object="none"

                    />
                    <m-control
                        :background-gray="true"
                        type="search"
                        label="Agrofag"
                        placeholder="Znajdź..."
                        name="agrofags"
                        model-name="agrofags"
                        @input="build('agrofag_id', $event)"
                        :value="query['agrofags']"
                        :search-at-once="true"
                        object="none"
                        :params="{crop_id: this.activeCropId}"
                    />
                     <m-control
                        type="range"
                        label="Zagrożenie"
                        name="danger"
                        :value="query['danger']"
                        model-name="danger"
                        @input="build('danger', $event)"
                        :items="5"
                        class=""
                    />
                </div>
            </div>
        </div>

        <o-list
            vuex-action-fetch="fetchAlerts"
            vuex-action-fetch-next-page="fetchAlertsNextPage"
            vuex-getter-model="alerts"
            vuex-getter-status="alertsStatus"
            router-single-name="alert"
        >
            <template slot="list" slot-scope="props">
                <p class="m-list__itemTitle m-list__itemTitle--bold">
                    {{ `Alert ${props.list.item.id}` }}
                </p>
                <p class="m-list__itemDate">
                    {{
                        $dayjs(props.list.item.created_at).format(
                            'DD.MM.YYYY, HH:mm:ss'
                        )
                    }}
                </p>
                <div class="m-list__itemHeader">
                    <div
                        v-if="
                            props.list.item.agrofags &&
                                props.list.item.agrofags.length > 0
                        "
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="AgrofagSmall"
                        />
                        {{ props.list.item.agrofags[0].name }}
                        <template v-if="props.list.item.agrofags.length > 1"
                            ><br />i inne</template
                        >
                    </div>
                    <div
                        v-if="
                            props.list.item.crops &&
                                props.list.item.crops.length > 0
                        "
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="CropSmall"
                        />
                        {{ props.list.item.crops[0].name }}
                        <template v-if="props.list.item.crops.length > 1"
                            ><br />i inne</template
                        >
                    </div>
                    <div
                        v-if="
                            props.list.item.counties &&
                                props.list.item.counties.length > 0
                        "
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="RegionSmall"
                        />
                        {{ props.list.item.counties[0].name }}
                        <template v-if="props.list.item.counties.length > 1"
                            ><br />i inne</template
                        >
                    </div>
                    <div
                        v-if="
                            props.list.item.counties &&
                                props.list.item.counties.length > 0
                        "
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="RegionSmall"
                        />
                        woj. {{ props.list.item.counties[0].province_name }}
                        <template v-if="props.list.item.counties.length > 1"
                            ><br />i inne</template
                        >
                    </div>
                     <div
                        v-if="props.list.item.danger"
                        class="m-list__itemHeaderCell m-list__itemDanger"
                        >
                            Poz. zagrożenia <span class="m-list__itemDangerNumber">{{ props.list.item.danger }}</span>

                    </div>
                </div>

                <div
                    v-if="props.list.item.description_trunc"
                    class="m-list__itemDescription"
                >
                    {{ props.list.item.description_trunc }}
                </div>
            </template>
        </o-list>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Alerty',
        meta: [
            {
                name: 'viewport',
                content:
                    'width=device-width,initial-scale=1.0,maximum-scale=1.0'
            }
        ]
    },
    data() {
        return {
            isMapOpened: false,
            activeProvinceId: null,
            activeCountyId: null,
            activeAgrofagId: null,
            activeCropId: null,
            date: {
                startDate: this.$dayjs()
                    .subtract('14', 'day')
                    .format('YYYY-MM-DD'),
                endDate: this.$dayjs().format('YYYY-MM-DD')
            },
            timeout: null
        }
    },
    computed: {
        query() {
            return this.$store.getters.alertsQuery
        },
        provinceList() {
            return this.$store.getters.provinceList
        },
        pointList() {
            return this.$store.getters.pointList
        },

        countiesList() {
            return this.$store.getters.countiesList
        },
        dateRange: {
            get() {
                return this.date
            },
            set(dateRange) {
                this.$set(this, 'date', dateRange)
                this.buildDate('date_start', dateRange.startDate)
                setTimeout(() => {
                    this.buildDate('date_end', dateRange.endDate)
                }, 1000)
            }
        },
        alerts() {
            return this.$store.getters.alerts
        },
        alertsStatus() {
            return this.$store.getters.alertsStatus
        },
        heatmapPoints() {
            return this.alerts.map(alert => {
                const item = {
                    lat: alert.latitude,
                    lng: alert.longitude
                }
                return item
            })
        }
    },
    watch: {
        alertsStatus() {
            if (window.google !== undefined) {
                const map = new window.google.maps.Map(this.$refs.heatmap, {
                    center: new window.google.maps.LatLng(52.126525, 19.400937),
                    zoom: 5,
                    disableDefaultUI: true
                })

                const styles = [
                    {
                        featureType: 'poi.business',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }]
                    }
                ]
                map.setOptions({ styles })

                // add markers for each point and build bounds
                const bounds = new window.google.maps.LatLngBounds()
                this.heatmapPoints.forEach(item => {
                    const pos = new window.google.maps.LatLng(item.lat, item.lng)
                    // eslint-disable-next-line no-new
                    new window.google.maps.Marker({
                        position: pos,
                        map
                    })
                    bounds.extend(pos)
                })

                // fit map to markers if any
                if (this.heatmapPoints.length > 0) {
                    map.fitBounds(bounds)
                    // optional: prevent over-zooming on single/few markers
                    window.google.maps.event.addListenerOnce(map, 'idle', () => {
                        const maxZoom = 12
                        if (map.getZoom() > maxZoom) {
                            map.setZoom(maxZoom)
                        }
                    })
                }
            }
        }
    },
    methods: {
        async build(name, value) {
            if (this.timeout) clearTimeout(this.timeout)

            // Zapamiętaj wybrane id (lub wyczyść przy skasowaniu filtra)
            const active = {
                province_id: 'activeProvinceId',
                county_id: 'activeCountyId',
                crop_id: 'activeCropId'
            }
            if (active[name]) {
                this[active[name]] = value && value.id ? value.id : null
                // zmiana województwa unieważnia wybrany powiat
                if (name === 'province_id' && !value) this.activeCountyId = null
            }

            if (name === 'danger' && value) {
                const danger = [
                    { id: 1, value: 1 },
                    { id: 2, value: 2 },
                    { id: 3, value: 3 },
                    { id: 4, value: 4 },
                    { id: 5, value: 5 }
                ]

                value = danger.find(item => item.value === value)
            }

            this.timeout = setTimeout(() => {
                this.$store
                    .dispatch('setAlertsSearchQuery', {
                        name,
                        value: value && value.id !== undefined ? value.id : (value ?? '')
                    })
                    .then(() => {
                        this.$store.dispatch('fetchAlerts').catch(() => {})
                    })
            }, 500)
        },
        buildDate(name, value) {
            this.$store
                .dispatch('setAlertsSearchQuery', {
                    name,
                    value
                })
                .then(() => {
                    this.$store.dispatch('fetchAlerts').catch(() => {})
                })
        },
        handleGoogleMaps() {},
        toggleMap() {
            this.isMapOpened = !this.isMapOpened
        }
    },
    created() {
        this.$store.dispatch('setAlertsSearchQuery', {
            name: 'status_symbol',
            value: 'published'
        })
        this.$store.dispatch('setAlertsSearchQuery', {
            name: 'date_start',
            value: this.date.startDate
        })
        this.$store.dispatch('setAlertsSearchQuery', {
            name: 'date_end',
            value: this.date.endDate
        })

        window.checkAndAttachMapScript(this.handleGoogleMaps)
    },
    unmounted() {
        this.activeCropId = null
        this.activeAgrofagId = null
        this.activeProvinceId = null
        this.activeCountyId = null
    }

}
</script>
